export const INTERNAL_BRAND = Object.freeze({
  name: 'HarmonIA',
  stem: 'Harmon',
  accent: 'IA',
  tagline: 'Operação, performance e gestão jurídica',
  symbolPath: '/brand/voile-solution-harmonia-v1.png',
  faviconPath: '/brand/voile-solution-harmonia-v1.png',
  artworkPath: '/brand/voile-solution-harmonia-v1.png',
})

export const PORTAL_BRAND = Object.freeze({
  name: 'Adjutorem IA',
  stem: 'Adjutorem',
  accent: 'IA',
  tagline: 'Gestão jurídica e provisões',
  symbolPath: '/brand/voile-solution-adjutorem-v2.png',
  faviconPath: '/brand/voile-solution-adjutorem-v2.png',
  artworkPath: '/brand/voile-solution-adjutorem-v2.png',
})
